/* W-053 step 3b -- THE ONE VIEW-ONLY WRAPPER (Brian 2026-10-07, option (a): a viewer's edit controls are SHOWN GREYED).
   Every edit region on the model pages is wrapped in <ViewOnly canEdit={canEditModel}>. For a user who may edit the model it
   renders its children EXACTLY as before -- a fragment, no element, so an admin's markup and layout do not change. For a
   viewer it wraps them in a DISABLED fieldset (display:contents, so the layout does not change either), which disables every
   native input / select / textarea / button inside, including those rendered by NumInput / DateInputMDY / ISLinePicker /
   RenewalControls; and a span carrying the hover note (a disabled control fires no mouse events of its own, so the note sits
   on an ancestor). The precedent is ScenariosPage's roCard (a scenario shared with you).
   RULES: (1) a region holds WRITE controls only -- a view control (a tab, a period toggle, a filter, Show / Hide) stays
   OUTSIDE it; (2) in a dialog, Cancel / Close stay OUTSIDE it; (3) never put it between a <table> and its rows (a span or a
   fieldset is not valid inside <tbody> / <tr>) -- wrap the whole table, or a cell's content. The standing check is
   server/diagnostics/verify-view-only.js (run by the client prebuild). Display gating only: the server refuses a viewer
   every model write ('Your login is view-only.'). */
import React from 'react';

export const VIEW_ONLY_NOTE = 'Your login is view-only.';
export const VIEW_ONLY_SETTINGS = "View only \u2014 your login can't change these settings.";

const FIELDSET_STYLE = { display: 'contents', border: 0, margin: 0, padding: 0, minWidth: 0 };
const SPAN_STYLE = { display: 'contents' };

export default function ViewOnly({ canEdit, children }) {
    if (canEdit) return <>{children}</>;
    return (
        <span title={VIEW_ONLY_NOTE} data-view-only="" style={SPAN_STYLE}>
            <fieldset disabled style={FIELDSET_STYLE}>{children}</fieldset>
        </span>
    );
}

/* W-053 3b.2 -- a NON-control the page makes inert for a viewer (a clickable text link, not a native control the fieldset can
   disable) carries these props: the hover note, and [data-view-only-inert], which index.css gives the SAME look as a disabled
   control in a view-only region. One rule, so the link and the buttons beside it cannot drift apart. An editor gets {}. */
export const viewOnlyInertProps = canEdit => (canEdit ? {} : { 'data-view-only-inert': '', title: VIEW_ONLY_NOTE });

/* The one line a viewer sees where the page would otherwise tell them their changes save, or invite them to add something. */
export function ViewOnlyNote({ style }) {
    return <span data-view-only-note="" style={{ color: '#888', fontStyle: 'italic', ...(style || {}) }}>{VIEW_ONLY_SETTINGS}</span>;
}
